import React from 'react'
import LogoWhiteAnimator from "../logoWhiteAnimator";
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <div>
            <div className="not_found_page">
                <div className="text-center">
                    <h2 className="py-2 text-black">
                        Page Not Found
                    </h2>
                    <LogoWhiteAnimator />
                    <Link className='btn btn-1 my-3' to="/">
                        Goto Homepage
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default NotFoundPage